import { useTranslation } from "react-i18next";
import { TbCheck, TbInfoCircle } from "react-icons/tb";
import { PLAN_PRICES } from "../registerTypes";

interface PlanFeature { labelKey: string; value: string; }
interface Plan { id: number; nameKey: string; price: string; features: PlanFeature[]; }

const PLANS: Plan[] = [
    {
        id:    1,
        nameKey: "register.planBasic",
        price: PLAN_PRICES[1],
        features: [
            { labelKey: "charges.planCompIncludedDoctors", value: "1" },
            { labelKey: "charges.planCompInvoicesPerDoctor", value: "100" },
            { labelKey: "register.planFeatureSms", value: "€0.09" },
            // Card payment in the patient portal via the practice's own SumUp account (every plan).
            { labelKey: "register.planFeatureCardPayment", value: "" },
        ],
    },
    {
        id:    2,
        nameKey: "register.planPlus",
        price: PLAN_PRICES[2],
        features: [
            { labelKey: "charges.planCompIncludedDoctors", value: "2 + 1" },
            { labelKey: "charges.planCompInvoicesPerDoctor", value: "200" },
            { labelKey: "register.planFeatureSms", value: "€0.09" },
            { labelKey: "register.planFeatureCardPayment", value: "" },
        ],
    },
    {
        id:    3,
        nameKey: "register.planPro",
        price: PLAN_PRICES[3],
        features: [
            { labelKey: "charges.planCompIncludedDoctors", value: "2 + 2" },
            { labelKey: "charges.planCompInvoicesPerDoctor", value: "∞" },
            { labelKey: "register.planFeatureSmsIncluded", value: "" },
            { labelKey: "register.planFeatureCardPayment", value: "" },
        ],
    },
];

interface Props { plan: number; onChange: (plan: number) => void; }

export default function StepPlan({ plan, onChange }: Props) {
    const { t } = useTranslation();

    return (
        <div className="register-step">
            <div className="register-plan-grid">
                {PLANS.map(p => (
                    <button
                        key={p.id}
                        type="button"
                        className={`register-plan-card register-plan-card--${p.id}${plan === p.id ? " register-plan-card--selected" : ""}`}
                        onClick={() => onChange(p.id)}
                    >
                        <div className="register-plan-card__name">{t(p.nameKey, { defaultValue: p.nameKey })}</div>
                        <div className="register-plan-card__price">
                            {p.price}<span className="register-plan-card__asterisk">*</span>
                            {p.id < 4 && <span className="register-plan-card__per">{t("register.perMonth")}</span>}
                        </div>
                        <ul className="register-plan-card__features">
                            {p.features.map(f => (
                                <li key={f.labelKey}>
                                    <TbCheck className="register-plan-card__check" />
                                    {t(f.labelKey, { defaultValue: f.labelKey })}
                                    {f.value ? `: ${f.value}` : ""}
                                </li>
                            ))}
                        </ul>
                        {plan === p.id && (
                            <div className="register-plan-card__badge">{t("register.selected")}</div>
                        )}
                    </button>
                ))}
            </div>
            <p className="register-plan-tax-note">* {t("register.priceExclVat", { defaultValue: "Alle Preise zzgl. gesetzlicher MwSt." })}</p>
            <div className="register-plan-notices">
                <p className="register-plan-notice register-plan-notice--info">
                    <TbInfoCircle className="register-plan-notice__icon" />
                    <span>{t("register.trialNotice")}</span>
                </p>
                <p className="register-plan-notice register-plan-notice--info">
                    <TbInfoCircle className="register-plan-notice__icon" />
                    <span>{t("register.smsPostNotice")}</span>
                </p>
                <p className="register-plan-notice register-plan-notice--info">
                    <TbInfoCircle className="register-plan-notice__icon" />
                    <span>{t("register.manageSubscriptionNotice")}</span>
                </p>
            </div>
        </div>
    );
}
